import React from "react";
import cx from "classnames";

import Box from "ds/components/Box";
import { InfoCircle } from "components/icons/generated";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

type WarningBarProps = {
  className?: string;
  topMargin?: boolean;
  children: React.ReactNode;
};

const WarningBar = ({ children, className, topMargin }: WarningBarProps) => (
  <div className={cx(styles.warningBar, { [styles.warningBarTop]: topMargin }, className)}>
    <div className={styles.warningBarText}>{children}</div>
    <Box className={styles.warningBarIcon}>
      <Icon src={InfoCircle} />
    </Box>
  </div>
);

export default WarningBar;
